import React from 'react';
import { useTranslation } from 'react-i18next';
import { required } from '../../../../../../antd/form/FormValidation.js';
import FormButton from '../../../../../../antd/form/FormButton/FormButton';
import FormButtonsContainer from '../../../../../../antd/form/FormButtonsContainer/FormButtonsContainer';
import Form from '../../../../../../antd/form/Form/Form';
import { CollapseBlock, Spinner } from '../../../../../../common/index';
import FormTextField from '../../../../../../antd/form/FormTextField/FormTextField';
import { Col, Row } from 'antd';
import FormSwitch from '../../../../../../antd/form/FormSwitch/FormSwitch';
import FormTextArea from '../../../../../../antd/form/FormTextArea/FormTextArea';
import FormNumberField from '../../../../../../antd/form/FormNumberField/FormNumberField';
import FormFileUpload from '../../../../../../antd/form/FormFileUpload/FormFileUpload';

const ErasmusUniversitiesForm = ({ onSubmit, initials, isPreview }) => {
  const { t } = useTranslation();

  if (!initials) {
    return <Spinner />;
  }

  return (
    <Form onFinish={onSubmit} initialValues={initials}>
      <CollapseBlock title={t('Základné údaje')} collapsible="false">
        <Row gutter={[16, 16]}>
          <Col span={20}>
            <FormTextField
              label={t('Názov')}
              name={'name'}
              rules={[required(t)]}
              disabled={isPreview}
            />
          </Col>
          <Col span={4}>
            <FormSwitch
              label={t('Aktívna')}
              name={'active'}
              disabled={isPreview}
            />
          </Col>
        </Row>
        <Row gutter={[16, 16]}>
          <Col span={12}>
            <FormTextField
              label={t('Krajina')}
              name={'country'}
              disabled={isPreview}
            />
          </Col>
          <Col span={12}>
            <FormTextField
              label={t('Mesto')}
              name={'city'}
              disabled={isPreview}
            />
          </Col>
        </Row>
        <Row gutter={[16, 16]}>
          <Col xs={24} md={8}>
            <FormTextField
              label={t('OID')}
              name={'OID'}
              rules={[required(t)]}
              disabled={isPreview}
            />
          </Col>
          <Col xs={24} md={8}>
            <FormTextField
              label={t('Erasmus kód')}
              name={'erasmus_code'}
              rules={[required(t)]}
              disabled={isPreview}
            />
          </Col>
          <Col xs={24} md={8}>
            <FormTextField
              label={t('PIC')}
              name={'PIC'}
              rules={[required(t)]}
              disabled={isPreview}
            />
          </Col>
        </Row>
        <FormTextArea
          label={t('Popis')}
          name={'description'}
          disabled={isPreview}
        />
        <Row gutter={[16, 16]}>
          <Col xs={24} md={12}>
            <FormTextField
              label={t('Webová stránka')}
              name={'website'}
              rules={[required(t)]}
              disabled={isPreview}
            />
          </Col>
          <Col xs={24} md={6}>
            <FormNumberField
              label={t('Zemepisná dĺžka')}
              name={'longitude'}
              rules={[required(t)]}
              style={{ width: '100%' }}
              disabled={isPreview}
            />
          </Col>
          <Col xs={24} md={6}>
            <FormNumberField
              label={t('Zemepisná šírka')}
              name={'latitude'}
              rules={[required(t)]}
              style={{ width: '100%' }}
              disabled={isPreview}
            />
          </Col>
        </Row>
        <FormFileUpload
          label={t('Titulná fotka')}
          name={'title_photo_path'}
          rules={[required(t)]}
          disabled={isPreview}
        />
      </CollapseBlock>
      <CollapseBlock title={t('Kontaktná osoba')} collapsible="false">
        <FormTextField
          label={t('Meno a priezvisko')}
          name={'contact_person'}
          //rules={[required(t)]}
          disabled={isPreview}
        />
        <Row gutter={[16, 16]}>
          <Col xs={24} md={8}>
            <FormTextField
              label={t('Email')}
              name={'email'}
              //rules={[required(t)]}
              disabled={isPreview}
            />
          </Col>
          <Col xs={24} md={8}>
            <FormTextField
              label={t('Telefonický kontakt')}
              name={'phone'}
              //rules={[required(t)]}
              disabled={isPreview}
            />
          </Col>
        </Row>
      </CollapseBlock>
      {isPreview ? null : (
        <FormButtonsContainer>
          <FormButton submitOnClick={true} submitKey={'erasmusApplications'}>
            {t('Uložiť')}
          </FormButton>
        </FormButtonsContainer>
      )}
    </Form>
  );
};

export default ErasmusUniversitiesForm;
